export const environment = {
   production: false,
   url: 'https://rc.myportfolios.ca/api/'
};
